module.exports = __webpack_public_path__ + "assets/img/37_1476.9a568585.jpg";